module.exports = __webpack_public_path__ + "static/img/klosterforst.4fc3d64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/STE_Klosterforst/klosterforst.png
// module id = drGi
// module chunks = 0